import { FC } from 'react'
import { IconPaths, LocalVideoChamada } from '_metronic/helpers/enumsUI'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button } from 'app/components/Button/Button'
import { useChamadaAtiva } from '../ChamadaAtivaProvider'

/**
 * Lugar do vídeo na tela do atendimento. O player não é renderizado aqui: o host move para cá o nó onde
 * ele está montado. O "Minimizar" fica na barra de controles do player; com o vídeo no PiP essa barra vai
 * junto para a janela (e lá fica oculta), então é aqui, na página, que fica o "Trazer vídeo de volta" —
 * o caminho por teclado (o X da janela PiP é só mouse). Centro inferior: livre dos controles do player.
 */
export const EncaixeChamada: FC = () => {
  const { registrarEncaixe, restaurar, localDoVideo } = useChamadaAtiva()
  const { t } = useT()

  return (
    <div className='position-relative w-100 h-100'>
      <div ref={registrarEncaixe} className='w-100 h-100' />
      {localDoVideo === LocalVideoChamada.Pip && (
        <Button
          className='btn-secondary position-absolute bottom-0 start-50 translate-middle-x mb-5 z-index-3'
          size='btn-sm'
          icon={IconPaths.Pip}
          onClick={restaurar}
        >
          {t('atendimento.chamada.restaurar')}
        </Button>
      )}
    </div>
  )
}
